import { useFeedbackAlerts } from "../../../_app/hooks";
import { useAuthSession, useDisableMfa, useMfaEnabled } from "../../../auth/hooks";
import { UIConfirm } from "../../../_app/components";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const DisableMFADialog = ({ open, onClose }: Props) => {
  const { setFeedbackAlertError } = useFeedbackAlerts();
  const { data: session } = useAuthSession();
  const accessToken = session?.accessToken ?? "";
  const { data: hasMfaEnabled } = useMfaEnabled(accessToken);
  const { mutateAsync: executeDisableMfa, isPending: isLoading } = useDisableMfa();

  const handleDisableMfa = async () => {
    if (!hasMfaEnabled) {
      setFeedbackAlertError("MFA is already disabled.");
      return;
    }
    // Awaited by UIConfirm so the dialog stays open (with a spinner) until the request settles.
    await executeDisableMfa();
  };

  return (
    <UIConfirm
      isDelete
      open={open}
      setOpen={onClose}
      onCancel={onClose}
      onConfirm={handleDisableMfa}
      isProcessing={isLoading}
      onSubmitTitle="Disable MFA"
      title="Are you sure you want to disable Multi-Factor Authentication (MFA)?"
    >
      Disabling MFA will remove the extra layer of security from your account, making it easier to log in but less secure.
      {"\n\n"}
      We recommend keeping MFA enabled to help protect your account.
    </UIConfirm>
  );
};

export default DisableMFADialog;
